import React, { useState } from 'react';
import { storage } from '../utils/storage';

function Login({ setCurrentUser }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const login = async () => {
    if (!email || !password) {
      alert('Please fill in all fields');
      return;
    }

    const user = await storage.getUser(email);
    if (user && user.password === password) {
      await storage.setCurrentUser(email);
      setCurrentUser(email);
    } else {
      alert('Invalid credentials');
    }
  };

  const register = async () => {
    if (!email || !password) {
      alert('Please fill in all fields');
      return;
    }

    const existingUser = await storage.getUser(email);
    if (existingUser) {
      alert('User already exists');
      return;
    }

    const newUser = {
      email,
      password,
      assessments: [],
      createdAt: new Date().toISOString(),
      lastActivity: new Date().toISOString()
    };
    
    await storage.setUser(email, newUser);
    await storage.setCurrentUser(email);
    setCurrentUser(email);
  };

  return (
    <div id="login-container">
      <div className="login-form">
        <h1>Career Assessment Tools</h1>
        <p>Discover your ideal career path</p>
        <h2>Login / Register</h2>
        <input 
          type="email" 
          placeholder="Email" 
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input 
          type="password" 
          placeholder="Password" 
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button onClick={login}>Login</button>
        <button onClick={register}>Register</button>
      </div>
    </div>
  );
}

export default Login;